export { default as FullScreenHeroWithImageSlider } from './FullScreenHeroWithImageSlider';
export { default as SimpleCentered } from './SimpleCentered';
export { default as FeaturesWithMobileScreenshot } from './FeaturesWithMobileScreenshot';
export { default as FeaturesWithMobileScreenshot2 } from './FeaturesWithMobileScreenshot2';
export { default as FeaturesWithMobileScreenshot3 } from './FeaturesWithMobileScreenshot3';
export { default as FeaturesWithMobileScreenshot4 } from './FeaturesWithMobileScreenshot4';
export { default as SimpleCentered2 } from './SimpleCentered2';
